import axiosClient from "./axiosClient";
import { create } from "domain";
import { async } from "q";
import {
  getBank,
  searchBangLuong,
  searchBHXH,
  searchCandidateDirectory,
  searchCauHinhLuong,
  searchChamCong,
  searchDimuon,
  searchLamThem,
  searchNghiBu,
  searchRecruiment,
  searchStandardWorkMonth,
  searchTNCN,
  searchTraning,
} from "../redux/reducer/employee";
import { data } from "pages/Refractive/InforDetails/SpectaclesCondition/config";

const employeeService = {
  // danh mục nhan viên ------------------------------------

  getEmployee: async (id) => {
    const url = "hanhchinhnhansu/nhan-vien";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data.data;
  },
  getNoiCap: async () => {
    const url = "hanhchinhnhansu/nhan-vien/danh-sach-noi-cap-cccd";
    const response = await axiosClient.get(url);
    return response.data;
  },
  getMaNhanVien: async () => {
    const url = "hanhchinhnhansu/nhan-vien/ma-nhan-vien";
    const response = await axiosClient.get(url);
    return response.data;
  },
  uploadEmployee: async (formData) => {
    const url = `hanhchinhnhansu/nhan-vien/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  searchEmployee: async (params) => {
    const url = "hanhchinhnhansu/nhan-vien/search";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  exportEmployee: async (params) => {
    const url = "hanhchinhnhansu/nhan-vien/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  updateDetailsEmployee: async (data) => {
    const url = `hanhchinhnhansu/nhan-vien`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deleteEmployee: async (id) => {
    const url = "hanhchinhnhansu/nhan-vien";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  uploadFileEmployee: async (data, id, type) => {
    const url = `hanhchinhnhansu/file/nhan-vien?id=${id}&type=${type}`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.put(url, data, {
      headers: headers,
    });
    return response.data;
  },
  // getDownlFile: async (id) => {
  //   const token = localStorage.getItem("token");
  //   const url = `/hanhchinhnhansu/file/view?id=${id}`;

  //   return url;
  // },
  // danh mục hợp dồng -------------------------------------

  deleteContract: async (id) => {
    const url = "hanhchinhnhansu/hop-dong";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  uploadHD: async (formData) => {
    const url = `hanhchinhnhansu/hop-dong/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  editContract: async (data) => {
    const url = "hanhchinhnhansu/hop-dong";
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  statusEmp: async (data) => {
    const url = "hanhchinhnhansu/hop-dong/status";
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  getContract: async (id) => {
    const url = "hanhchinhnhansu/hop-dong";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getNumberContract: async (id) => {
    const url = "hanhchinhnhansu/hop-dong/so-hop-dong";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getHD: async (id) => {
    const url = `hanhchinhnhansu/nhan-vien/hop-dong`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  getListNV: async (id) => {
    const url = `hanhchinhnhansu/hop-dong/thong-tin-nghi-viec`;
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  createWorkHistory: async (data) => {
    const url = "hanhchinhnhansu/lich-su-cong-tac";
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  // danh muc giay phép -------------------------------------------------------

  editLicense: async (data) => {
    const url = "hanhchinhnhansu/giay-phep";
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  getPhamVi: async (id) => {
    const url = "hanhchinhnhansu/pham-vi-hoat-dong-chuyen-mon";
    const params = { id: id };
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteLicense: async (id) => {
    const url = "hanhchinhnhansu/giay-phep";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  getGiayPhep: async (id) => {
    const url = "hanhchinhnhansu/giay-phep";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getLishSuCongTac: async (params) => {
    const url = "hanhchinhnhansu/list-lich-su-cong-tac";
    const response = await axiosClient.post(url, params);
    return response;
  },

  // danh mục chức vụ ---------------------------------------------

  getPosition: async (params) => {
    const url = "hanhchinhnhansu/list-chuc-vu";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  createPosition: async (data) => {
    const url = "hanhchinhnhansu/chuc-vu";
    const response = await axiosClient.post(url, data);
    return response;
  },
  editPosition: async (data) => {
    const url = "hanhchinhnhansu/chuc-vu";
    const response = await axiosClient.put(url, data);
    return response;
  },
  deletePosition: async (id) => {
    const url = "hanhchinhnhansu/chuc-vu";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  // danh mục phòng ban -------------------------------------------------

  getDepartment: async (params) => {
    const url = "hanhchinhnhansu/list-danh-muc-phong-ban";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  deleteDepartment: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-phong-ban";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  createDepartment: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-phong-ban";
    const response = await axiosClient.post(url, data);
    return response;
  },
  editDepartment: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-phong-ban";
    const response = await axiosClient.put(url, data);
    return response;
  },

  // danh mục nhóm công việc -------------------------------------------------

  getLCV: async (params) => {
    const url = "hanhchinhnhansu/list-nhom-cong-viec";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  deleteCV: async (id) => {
    const url = "hanhchinhnhansu/nhom-cong-viec";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },

  createCV: async (data) => {
    const url = "hanhchinhnhansu/nhom-cong-viec";
    const response = await axiosClient.post(url, data);
    return response;
  },
  editCV: async (data) => {
    const url = "hanhchinhnhansu/nhom-cong-viec";
    const response = await axiosClient.put(url, data);
    return response;
  },

  // danh mục loại hợp dồng -------------------------------------------------

  getLHD: async (params) => {
    const url = "hanhchinhnhansu/list-danh-muc-loai-hop-dong";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  createLHD: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-loai-hop-dong";
    const response = await axiosClient.post(url, data);
    return response;
  },
  editLHD: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-loai-hop-dong";
    const response = await axiosClient.put(url, data);
    return response;
  },
  deleteLHD: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-loai-hop-dong";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },
  getIdLHD: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-loai-hop-dong";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  // danh mục ngày nghỉ phép -------------------------------------------------

  getNghiPhep: async (params) => {
    const url = "hanhchinhnhansu/list-danh-muc-ngay-nghi";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  createNghiPhep: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-ngay-nghi";
    const response = await axiosClient.post(url, data);
    return response;
  },
  editNghiPhep: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-ngay-nghi";
    const response = await axiosClient.put(url, data);
    return response;
  },
  deleteNghiPhep: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-ngay-nghi";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },
  // Danh mục số giờ làm việc/tuần ---------------------------------------------------------

  getWorking: async (params) => {
    const url = "hanhchinhnhansu/list-danh-muc-so-gio-lam-viec-tuan";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  createEditWorking: async (data) => {
    const url = "hanhchinhnhansu/danh-muc-so-gio-lam-viec-tuan";
    const response = await axiosClient.post(url, data);
    return response;
  },
  deleteWorking: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-so-gio-lam-viec-tuan";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response;
  },
  //Danh mục địa chỉ làm việc ------------------------------------------------------------------------
  getWordAddress: async (params) => {
    const url = "hanhchinhnhansu/dia-chi-lam-viec/get-all";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getListAddress: async (params) => {
    const url = "hanhchinhnhansu/dia-chi-lam-viec/find-all";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  createWordAddress: async (data) => {
    const url = "hanhchinhnhansu/dia-chi-lam-viec/create-update";
    const response = await axiosClient.post(url, data);
    return response;
  },
  deleteWordAddress: async (id) => {
    const url = `hanhchinhnhansu/dia-chi-lam-viec/delete?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  // Công chuẩn tháng ------------------------------------------------------------------------

  searchStandardWorkMonth: async (params) => {
    const url = "hanhchinhnhansu/cong-chuan-thang/search";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  exportStandardWorkMonth: async (params) => {
    const url = "hanhchinhnhansu/cong-chuan-thang/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  updateStandardWorkMonth: async (data) => {
    const url = `hanhchinhnhansu/cong-chuan-thang`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deleteStandardWorkMonth: async (id) => {
    const url = "hanhchinhnhansu/cong-chuan-thang";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  // Khoá đào tạo ------------------------------------------------------------------------

  searchTraning: async (params) => {
    const url = "hanhchinhnhansu/khoa-dao-tao/search";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  deleteTraning: async (id) => {
    const url = "hanhchinhnhansu/khoa-dao-tao";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  deleteTraningNV: async (id) => {
    const url = "hanhchinhnhansu/nhan-vien-khoa-dao-tao";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateTraning: async (data) => {
    const url = `hanhchinhnhansu/khoa-dao-tao`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateTraningNV: async (data, id) => {
    const url = `hanhchinhnhansu/khoa-dao-tao/nhan-vien`;
    const params = { id: id };
    const response = await axiosClient.post(url, { data }, { params });
    return response.data;
  },
  getEmployeeTraning: async (id) => {
    const url = "hanhchinhnhansu/khoa-dao-tao/nhan-vien-tham-gia-khoa-dao-tao";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  uploadFileTraining: async (data, idKhaoDaoTao, idNhanVien) => {
    const url = `hanhchinhnhansu/khoa-dao-tao/upload-file-chung-chi?idKhoaDaoTao=${idKhaoDaoTao}&idNhanVien=${idNhanVien}`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.put(url, data, {
      headers: headers,
    });
    return response.data;
  },
  ///Lịch sử đào tạo
  getListHistoryTraining: async (body) => {
    const url = "hanhchinhnhansu/khoa-dao-tao/lich-su-dao-tao";
    const response = await axiosClient.post(url, body);
    return response.data.data.items;
  },
  ///////
  // Đợt tuyển dụng ----------------------------------------------------------------------
  searchRecruiment: async (params) => {
    const url = "hanhchinhnhansu/dot-tuyen-dung/search";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  getRecruitment: async (id) => {
    const url = "hanhchinhnhansu/dot-tuyen-dung";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getRecruitmentNew: async () => {
    const url = "hanhchinhnhansu/khoa-dao-tao/khoa-dao-tao-new";
    const response = await axiosClient.get(url);
    return response.data;
  },
  deleteRecruitment: async (id) => {
    const url = "hanhchinhnhansu/dot-tuyen-dung";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateRecruitment: async (data) => {
    const url = `hanhchinhnhansu/dot-tuyen-dung`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  // Ứng viên ----------------------------------------------------------------------

  searchCandidateDirectory: async (params) => {
    const url = "hanhchinhnhansu/danh-muc-ung-vien/search";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  updateCandidateDirectory: async (data) => {
    const url = `hanhchinhnhansu/danh-muc-ung-vien`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateCandidateDirectoryKQ: async (data) => {
    const url = `hanhchinhnhansu/danh-muc-ung-vien/danh-gia-ket-qua`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadFileCandidateDirectory: async (data, id) => {
    const url = `hanhchinhnhansu/danh-muc-ung-vien/upload-cv?id=${id}`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.put(url, data, {
      headers: headers,
    });
    return response.data;
  },
  getDetailFileCandidateDirectory: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-ung-vien/download-cv";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  deleteCandidateDirectory: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-ung-vien";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  getNewIdTD: async (id) => {
    const url = "hanhchinhnhansu/dot-tuyen-dung/new-id";
    const response = await axiosClient.get(url);
    return response.data.data;
  },
  getCandidateDirectory: async (id) => {
    const url = "hanhchinhnhansu/danh-muc-ung-vien/danh-gia-ket-qua";
    const params = { id: id };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  // Chấm công ----------------------------------------------------------------------
  searchChamCong: async (params) => {
    const url = "hanhchinhnhansu/list-cham-cong";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  phatSinhChamCong: async (params) => {
    const url = "hanhchinhnhansu/cham-cong/phat-sinh-ky-cong";
    const response = await axiosClient.post(url, params);
    return response;
  },
  deleteChamCong: async (id) => {
    const url = "hanhchinhnhansu/cham-cong";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateChamCong: async (data) => {
    const url = `hanhchinhnhansu/cham-cong`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadChamCong: async (formData) => {
    const url = `hanhchinhnhansu/cham-cong/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  exportChamCong: async (params) => {
    const url = "hanhchinhnhansu/cham-cong/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  updateKiCong: async (body) => {
    const url = `hanhchinhnhansu/cham-cong/cap-nhat-ky-cong`;
    const response = await axiosClient.post(url, body);
    return response.data;
  },
  // cấu hình lương ----------------------------------------------------------------------

  searchCauHinhLuong: async (params) => {
    const url = "hanhchinhnhansu/list-cai-dat-luong";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  deleteCauHinhLuong: async (id) => {
    const url = "hanhchinhnhansu/cai-dat-luong";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateCauHinhLuong: async (data) => {
    const url = `hanhchinhnhansu/cai-dat-luong`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadCauHinhLuong: async (formData) => {
    const url = `hanhchinhnhansu/cai-dat-luong`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  getNewIdCauHinhLuong: async (id) => {
    const url = "hanhchinhnhansu/cai-dat-luong/new-id";

    const response = await axiosClient.get(url);
    return response.data;
  },
  // Theo dõi đi muộn ----------------------------------------------------------------------

  searchDimuon: async (params) => {
    const url = "hanhchinhnhansu/list-di-muon";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteDimuon: async (id) => {
    const url = "hanhchinhnhansu/di-muon";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateDimuon: async (data) => {
    const url = `hanhchinhnhansu/di-muon`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadDimuon: async (formData) => {
    const url = `hanhchinhnhansu/di-muon/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  exportDimuon: async (params) => {
    const url = "hanhchinhnhansu/di-muon/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  // Theo dõi nghỉ bù ----------------------------------------------------------------------

  searchNghiBu: async (params) => {
    const url = "hanhchinhnhansu/list-nghi-bu";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  exportNghiBu: async (params) => {
    const url = "hanhchinhnhansu/nghi-bu/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },

  // bảng chấm công làm thêm giờ ----------------------------------------------------------------------

  searchLamThem: async (params) => {
    const url = "/hanhchinhnhansu/list-cham-cong-gio-lam-them";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteLamThem: async (id) => {
    const url = "hanhchinhnhansu/cham-cong-gio-lam-them";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateLamThem: async (data) => {
    const url = `/hanhchinhnhansu/cham-cong-gio-lam-them`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadLamThem: async (formData) => {
    const url = `hanhchinhnhansu/cham-cong-gio-lam-them/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  exportLamThem: async (params) => {
    const url = "hanhchinhnhansu/cham-cong-gio-lam-them/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  // Biểu thuế TNCN ------------------------------------------------------------------------

  searchTNCN: async (params) => {
    const url = "hanhchinhnhansu/list-bieu-thue-tncn";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  searchTNCNNop: async (id) => {
    const url = `/hanhchinhnhansu/list-bieu-thue-tncn-phai-nop?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data.data.items;
  },
  exportTNCN: async (params) => {
    const url = "hanhchinhnhansu/cong-chuan-thang/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  updateTNCN: async (data) => {
    const url = `/hanhchinhnhansu/bieu-thue-tncn`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deleteTNCN: async (id) => {
    const url = "hanhchinhnhansu/bieu-thue-tncn";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  getNewIdBT: async (id) => {
    const url = "/hanhchinhnhansu/bieu-thue-tncn/new-ma-bieu-thue";
    const response = await axiosClient.get(url);
    return response.data;
  },
  // theo dõi BHXH ------------------------------------------------------------------------

  searchBHXH: async (params) => {
    const url = "hanhchinhnhansu/list-theo-doi-bhxh";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  exportBHXH: async (params) => {
    const url = "hanhchinhnhansu/theo-doi-bhxh/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  deleteBHXH: async (id) => {
    const url = "hanhchinhnhansu/theo-doi-bhxh";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  // bảng lương ----------------------------------------------------------------------

  searchBangLuong: async (params) => {
    const url = "hanhchinhnhansu/list-bang-luong";
    const response = await axiosClient.post(url, params);
    return response.data.data;
  },
  searchDuyetBangLuong: async (params) => {
    const url = `hanhchinhnhansu/list-duyet-luong?trangThaiDuyet=${
      params.trangThaiDuyet || 0
    }`;
    const response = await axiosClient.post(url, params);
    return response.data.data || response.data;
  },
  deleteBangLuong: async (id) => {
    const url = "hanhchinhnhansu/cham-cong";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data.data;
  },
  updateBangLuong: async (data, thang, nam) => {
    const url = `hanhchinhnhansu/bang-luong/update?thang=${thang}&nam=${nam}`;
    const response = await axiosClient.post(url, { data: data });
    return response.data;
  },
  uploadBangLuong: async (formData) => {
    const url = `hanhchinhnhansu/bang-luong-thuong/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  exportBangLuong: async (params) => {
    const url = "hanhchinhnhansu/cham-cong/export-excel";
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  // lấy ngân hàng
  getBank: async () => {
    const url = "hanhchinhnhansu/nhan-vien/danh-muc-ngan-hang";
    const response = await axiosClient.get(url);
    return response.data;
  },

  //ca làm việc
  //Cấu hình ca làm việc
  getShiftWorkSetting: async (params) => {
    const url = "hanhchinhnhansu/ca-lam-viec/cau-hinh";
    const response = await axiosClient.get(url, { params: params });
    return response.data.data.items;
  },
  //Tạo và Update ca làm việc
  editShiftWorkSetting: async (body) => {
    const url = "/hanhchinhnhansu/ca-lam-viec";
    const res = await axiosClient.post(url, body);
    return res.data;
  },
  //Delete ca làm việc
  deleteShiftWorkSetting: async (id) => {
    const url = "hanhchinhnhansu/ca-lam-viec";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  getListShiftWorkSetting: async (params) => {
    const url = "hanhchinhnhansu/ca-lam-viec/ky-hieu-cham-cong";
    const response = await axiosClient.get(url, { params: params });
    return response.data.data.items;
  },
  //Phân ca làm việc
  getShiftList: async (params) => {
    const url = "hanhchinhnhansu/phan-ca/search";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  uploadPhanCa: async (formData) => {
    const url = `hanhchinhnhansu/phan-ca/import`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  //Edit ca làm việc
  editShiftList: async (params) => {
    const url = "hanhchinhnhansu/phan-ca";
    const response = await axiosClient.post(url, params);
    return response.data;
  },

  //Chấm công  thô
  importRoughtTimekeeping: async (data) => {
    const url = "hanhchinhnhansu/cham-cong-tho/import";

    const response = await axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
  updateRoughtTimekeeping: async (data) => {
    const url = `hanhchinhnhansu/cham-cong-tho`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  getListRoughtTImekeeping: async (params) => {
    const url = "/hanhchinhnhansu/list-cham-cong-tho";

    const response = await axiosClient.post(url, params);
    return response.data;
  },
  browseRoughtTimekeeping: async (params) => {
    const url = `hanhchinhnhansu/duyet-cham-cong-tho`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  ////Văn bản đi
  getListTextAway: async (params) => {
    const url = "/hanhchinhnhansu/van-ban-di";
    const response = await axiosClient.get(url, { params });
    return response.data.data;
  },
  deleteTextAway: async (id) => {
    const url = `hanhchinhnhansu/van-ban-di?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  updateTextAway: async (data) => {
    const url = `hanhchinhnhansu/van-ban-di`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadFileTextAway: async (data) => {
    const url = `hanhchinhnhansu/file/van-ban`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.put(url, data, {
      headers: headers,
    });
    return response.data;
  },
  getListFilesAway: async (type) => {
    const url = `/hanhchinhnhansu/file?type=${type}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getExportTextAway: async (param) => {
    const url = "hanhchinhnhansu/van-ban-di/export-excel";
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },
  ////Văn bản đến
  getListTextArrve: async (params) => {
    const url = "/hanhchinhnhansu/van-ban-den";
    const response = await axiosClient.get(url, { params });
    return response.data.data;
  },
  getExportTextArrive: async (param) => {
    const url = "hanhchinhnhansu/van-ban-den/export-excel";
    const response = await axiosClient.get(url, {
      params: param,
      responseType: "blob",
    });
    return response;
  },
  deleteTextArrve: async (id) => {
    const url = `hanhchinhnhansu/van-ban-den?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  updateTextArrve: async (data) => {
    const url = `hanhchinhnhansu/van-ban-den`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  uploadFileTextArrive: async (data) => {
    const url = `hanhchinhnhansu/file/van-ban`;
    const headers = { "Content-Type": "multipart/form-data" };
    const response = await axiosClient.put(url, data, {
      headers: headers,
    });
    return response.data;
  },
  getListFileOfDoc: async (id) => {
    const url = `/hanhchinhnhansu/file?vbId=${id}`;
    const params = { limit: 20, page: 1 };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDetailDoc: async (id) => {
    const url = `/hanhchinhnhansu/file/detail?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getBlobFile: async (id) => {
    const url = `/hanhchinhnhansu/file/view?id=${id}`;
    const response = await axiosClient.get(url, { responseType: "blob" });
    return response.data;
  },
  deleteFile: async (id) => {
    const url = `hanhchinhnhansu/file?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  ////Kỷ luật
  getListDiscipline: async (body) => {
    const url = "hanhchinhnhansu/ky-luat/get-all";
    const response = await axiosClient.post(url, body);
    return response.data.data.items;
  },
  deleteDiscipline: async (id) => {
    const url = `hanhchinhnhansu/ky-luat?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  updateDiscipline: async (data) => {
    const url = `hanhchinhnhansu/ky-luat`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  getDisciplinedemployees: async (params) => {
    const url = "hanhchinhnhansu/ky-luat/nhan-vien";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  //Duyệt lương
  getApprovePermissions: async (params) => {
    const url = "hanhchinhnhansu/duyet-luong/list-quyen-duyet";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  getApprovePersons: async (params) => {
    const url = "hanhchinhnhansu/duyet-luong/list-nguoi-duyet";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  getApproveStatus: async (params) => {
    const url = "hanhchinhnhansu/duyet-luong/list-trang-thai-duyet";
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  approvePayroll: async (body, action: string) => {
    const url = `hanhchinhnhansu/duyet-luong?action=${action}`;
    const response = await axiosClient.post(url, body);
    return response.data;
  },
  getQuantityApprove: async () => {
    const url = "hanhchinhnhansu/so-luong-phai-duyet";
    const response = await axiosClient.get(url);
    return response;
  },
  updatePayroll: async (body, date) => {
    const url = `hanhchinhnhansu/bang-luong/update?thang=${date.thang}&nam=${date.nam}`;
    const response = await axiosClient.post(url, body);
    return response;
  },

  createApprovePerson: async (body) => {
    const url = `hanhchinhnhansu/duyet-luong/nguoi-duyet`;
    const response = await axiosClient.post(url, body);
    return response;
  },
  updateApprovePerson: async (body) => {
    const url = `hanhchinhnhansu/duyet-luong/nguoi-duyet?username=${body.username}`;
    const response = await axiosClient.put(url, body);
    return response;
  },
  //Mẫu in
  getTemplateChamDutHDLD: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/cham-dut-hdld?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateBangDGTV: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/danh-gia-thu-viec?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateHDLDDCL: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/phu-luc-dieu-chinh-luong?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateHDTV: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/hop-dong-tu-van?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateHDLDL1: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/hop-dong-lao-dong-lan-1?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateHDKCB: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/hop-dong-kham-chua-benh?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateHDThuViec: async (hdId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/hop-dong-thu-viec?hd_id=${hdId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateTMNV: async (uvId: number | string) => {
    const url = `hanhchinhnhansu/mau-in/thu-moi-nhan-viec?uv_id=${uvId}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateDkNghiPhep: async (id: number | string) => {
    const url = `hanhchinhnhansu/mau-in/dang-ky-nghi-phep?id_dang_ky=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateThoaThuanDaoTao: async (id: number | string) => {
    const url = `hanhchinhnhansu/mau-in/thoa-thuan-dao-tao?kdt_id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateDangKyHanhNghe: async () => {
    const url = `hanhchinhnhansu/nhan-vien/mau-in/dang-ky-hanh-nghe`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTemplateTinhHinhSdLaoDong: async () => {
    const url = `hanhchinhnhansu/mau-in/tinh-hinh-sd-lao-dong`;
    const response = await axiosClient.get(url);
    return response;
  },
  //Đăng ký nghỉ phép
  getListRegister: async (body) => {
    const url = "hanhchinhnhansu/dang-ky-nghi-phep";
    const response = await axiosClient.post(url, body);
    return response.data;
  },
  updateRegister: async (data) => {
    const url = `hanhchinhnhansu/dang-ky-nghi-phep/create`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  updateListRegister: async (body) => {
    const url = `hanhchinhnhansu/dang-ky-nghi-phep/update`;
    const response = await axiosClient.put(url, body);
    return response;
  },
  deleteRegister: async (id) => {
    const url = `hanhchinhnhansu/dang-ky-nghi-phep/delete?id=${id}`;
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  getResgister: async (params) => {
    const url = "hanhchinhnhansu/dang-ky-nghi-phep/get-cau-hinh";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
};

export default employeeService;
